import { apiService } from '../../../shared/services/apiService';
import { ChallengeInfo } from '../../interfaces/ChallengeInfo';
import { ChallengeInfoService, GetChallengeInfoConfig } from './challengeInfoService';

export const publicChallengeInfoService: ChallengeInfoService = {
  async getChallengeInfo(
    challengeId: number,
    config?: GetChallengeInfoConfig,
  ): Promise<ChallengeInfo> {
    const response = await apiService.get(`api/public/challenges/${challengeId}`, config);

    return response.data;
  },
};
